<div id="online-banking">
  <NBFormSelect
    label="Select a bank"
    v-model="selectedbank"
    :options="bankOptions"
  />
</div>
